import React, {useEffect, useState} from "react";
import { useDispatch, useSelector } from 'react-redux';
import Spinner from "../_common/Spinner";
import List from "../_common/List";
import {getSensorsForMeasurements} from "../../store/actions/sensorReportsActions";
import {isCompanyUser, isCustomer, isDemoUser, isDistributorAdmin} from "../../helpers/helpers";
import './SensorListForMeasurement.scss'


const selector = state => {
    const { language, sensorReports, modalState } = state;
    return {
        t: language.translator,
        modalState: modalState,
        sensorListPending: sensorReports.sensorListPending,
        sensorsForMeasurements: sensorReports.sensorsForMeasurements,
        sensorTypes: sensorReports.sensorTypes
    }
};

const SensorListForMeasurement = props => {
    const { t, sensorListPending, sensorsForMeasurements, sensorTypes } = useSelector(selector);
    const {selectSensors, sensorPicker} = props;
    const dispatch = useDispatch();
    const [showTypeFilterOptions, setShowTypeFilterOptions] = useState(false);
    const [typeFilter, setTypeFilter] = useState({name: '', id: ''});

    const [selectedSensors, setSelectedSensors] = useState([])

    useEffect(() => {
        // if(!sensorsForMeasurements?.sensors) {
            dispatch(getSensorsForMeasurements({}))
        // }

    },[])

    const checkIfUser = () => {
        return isDemoUser() || isCustomer() || isCompanyUser();
    }

    const handleSelectSensors = (sensor) => {
        // let newValues = [...selectedSensors]
        //
        // if(selectedSensors.find(x => x === sensor.id)) {
        //     newValues = newValues.filter(x => x !== sensor.id)
        // } else {
        //     newValues.push(sensor.id)
        // }
        //
        // setSelectedSensors(newValues)
        selectSensors([sensor.id])
    }





    if(sensorListPending) {
        return (
            <div className='page'>
                <Spinner size={300}/>
           </div>
        )
    }

    return (
        <div className="SensorListForMeasurement">
            <div className="sensorListForMeasurementHeader">
                <div
                    className='filterTypeFormSelect'
                    onClick={() => setShowTypeFilterOptions(!showTypeFilterOptions)}
                >
                    <div className='filterTypeFormSelectText'>
                        {typeFilter.name ? typeFilter.name : t.gettext('Sensor type')}
                    </div>
                    <div className="iconHolder">
                        {/*{!isDistributorAdmin() &&*/}
                            <i className="material-icons dropDownIcon">
                                {showTypeFilterOptions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                            </i>
                        {/*}*/}
                        <span
                            className='material-icons cancelTypeIcon'
                            onClick={(e) => {
                                e.stopPropagation()
                                setTypeFilter({name: '', id: ''});
                                dispatch(getSensorsForMeasurements({}))
                            }}
                        >
                    cancel
                </span>
                    </div>

                    {showTypeFilterOptions &&
                        <div className='filterTypeFormSelectOptions'>
                            {sensorTypes.map((item, index) => (
                                <div
                                    className='filterTypeFormSelectOption'
                                    key={index}
                                    onClick={() => {
                                        setTypeFilter({name: item.name, id: item.id})
                                        dispatch(getSensorsForMeasurements({sensorType: item.name
                                        }));
                                    }}
                                >
                                    {item.name}
                                </div>
                            ))}
                        </div>
                    }

                </div>
                {/*<div className="selectSensorsBtn" onClick={() => selectSensors(selectedSensors)}>*/}
                {/*    {t.gettext('Select sensors')}*/}
                {/*</div>*/}
            </div>


            <div className={'sensorList'}>
                {sensorsForMeasurements && sensorsForMeasurements.sensors && (
                    <List
                        roundTopCorners
                        items={sensorsForMeasurements.sensors}
                        // page={page}
                        // itemsPerPage={itemsPerPage}
                        // pageCount={pageCount}
                        // itemsCount={itemsCount}
                        columnsNames={checkIfUser() ? ['Sensor Name', 'Last Measurement Time', 'Is Active'] : ['Lora Identifier', 'Sensor Name', 'Last Measurement Time','User Name', 'Is Active']}
                        columns={checkIfUser() ?  ['name', 'measurements', 'active'] : ['loraIdentifier', 'name', 'measurements', 'userName','active']}
                        columnsWidths={checkIfUser() ? ['40%', '30%', '30%'] : ['20%', '20%', '20%', '20%', '10%']}
                        // checkboxColumn
                        // selectCheckbox
                        // filter={filter}
                        measurementTimeColumn={checkIfUser() ? 2 : 3}
                        booleanColumn={checkIfUser() ? 3 : 5}
                        // getItemsMethod={getSensors}
                        picker={sensorPicker}
                        selectItemMethod={handleSelectSensors}
                        handleSelectSensors={handleSelectSensors}
                        selectedSensors={selectedSensors}
                    />
                )}
            </div>
        </div>

    )

}

export default SensorListForMeasurement
